import { useState, useEffect } from "react";
import PrintedChannelHeader from '../printedChannelHeader/PrintedChannelHeader';
import { tv } from '../../lib/api/api';

const PrintableCard = ({channel, date}) => {
    const [programs, setPrograms] = useState([]);

    useEffect(() => {
        tv.channelScheme(channel, date)
            .then((res) => {
                setPrograms(res.scheme.programs);
            })
            .catch((err) => {
                console.log(err);
            });
    }, [channel, date]);

    return (
        <>
            <div className="tv-program-print__channel">
                <PrintedChannelHeader channel={channel} date={date}/>
                <div className="tv-program-print__channel-body">
                    <ul className="tv-program-print__program">
                        {programs.map(program => (
                            <li className="tv-program-print__program-item">
                                <time className="tv-program-print__program-time" datetime={program.scheme.start_at.slice(-8)}>{program.scheme.start_at.slice(11, -3)}</time>
                                <span className="tv-program-print__program-name">{program.name}</span>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </>
    );
};

export default PrintableCard;